import * as Yup from "yup";

const re = /^\d+$/;

const ConfirmEmailSchema = Yup.object().shape({
  token: Yup.string().matches(re, "Please include numbers 0-9 only").min(6, "Minimum of 6 digits").required("Required"),
});

export default ConfirmEmailSchema;
